import Badminton from './Badminton';
import BaseBall from './BaseBall';
import BasketBall from './BasketBall';
import PCGame from './PCGame';
import PingPong from './PingPong';
import Soccer from './Soccer';
import Tennis from './Tennis';
import Volleyball from './Volleyball';
import Hockey from './Hockey';

export default {
  Badminton,
  BaseBall,
  BasketBall,
  PCGame,
  PingPong,
  Soccer,
  Tennis,
  Volleyball,
  Hockey,
};
